import List from '../pages/physical/List.vue'
import Router from "vue-router";
import store1 from "../store/index.js";

import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
] // to comment Landing route when using on dev mode

const physicalRoutes = [
  {
    path: '/list',
    name: 'Physical List',
    component: List,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  }
]

const routes = baseRoutes.concat(physicalRoutes)


const routerPhysical = new Router({
  routes,
  base: 'phy',
  mode: 'history'
})

routerPhysical.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})

export default routerPhysical